import { ensureHttps } from "@readcloud/common/build/lib/netUtils";
import "./app/index.module";
import { isProd } from "env";

if (isProd) {
  ensureHttps();
}
//Configure Recompose
